import { useEffect } from 'react';
import { useNavigate, useRoutes } from 'react-router-dom';
import GlobalStyles from 'src/components/GlobalStyles';
import 'src/mixins/chartjs';
import routes from 'src/routes';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { MAIN_TOKEN_KEY } from './constants';
import { get, remove } from './utils/storage';
import { auth } from './utils/firebase';
import { onAuthStateChanged } from 'firebase/auth';

const App = () => {
  const routing = useRoutes(routes);
  const navigate = useNavigate();

  useEffect(() => {
    // Firebase SDK manages token renewal. We only need to check whether
    // there's an active Firebase session. If yes, ensure localStorage has
    // a token (the onIdTokenChanged listener in firebase.js keeps it
    // fresh). If no session, redirect to login.
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Session alive — make sure localStorage is current.
        try {
          const freshToken = await user.getIdToken();
          const stored = get(MAIN_TOKEN_KEY);
          if (!stored) {
            // Tab was re-opened after a browser restart but Firebase
            // session persists (IndexedDB). Re-populate localStorage.
            const { set } = await import('./utils/storage');
            set(MAIN_TOKEN_KEY, freshToken);
          }
        } catch (_) {}
        // Only navigate on initial mount, not on every token refresh.
        if (window.location.pathname === '/' || window.location.pathname === '/login') {
          navigate('app/admins');
        }
      } else {
        // No Firebase session — clear stale localStorage and redirect.
        remove(MAIN_TOKEN_KEY);
        navigate('/login');
      }
    });
    return () => unsub();
  }, []);

  return (
    <>
      <GlobalStyles />
      {routing}
    </>
  );
};

export default App;
